import React, { createContext, useContext } from "react"
import { Organization, UserProfileItem } from "types/profile"
import { UserInfo } from "types/user"

export interface ProfileContextType {
    selfProfile: UserInfo | null
    isLoading: boolean
    organization: Organization | null
    userProfile: UserProfileItem[]

    clickOnPassword: boolean
    isPasswordPopinOpen: boolean
    organizationSuccess: boolean | null
    organizationLoading: boolean
    modifyEmail: () => void
    modifyPassword: () => void
    modifyLanguage: () => void
    setIsPasswordPopinOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export const ProfilePageContext = createContext<ProfileContextType | undefined>(
    undefined
)

export const useProfileContext = () => {
    const context = useContext(ProfilePageContext)
    if (context === undefined) {
        throw new Error(
            "useProfileContext doit être utilisé à l'intérieur de ProfilePageProvider"
        )
    }
    return context
}
